export class RefreshTTokenRequest {
    token: string = "";
  }
  